angular
	.module 'App.Repository'

.factory 'MerchantGroupRepository', ['BaseRepository', (BaseRepository) ->
	class MerchantGroupRepository extends BaseRepository
		@resource = '/merchant_groups'
		@isRestricted = true

	return new MerchantGroupRepository()
]
